import httpInstance from './interceptor'
import { throwErr } from './throwError'

export const getAllList = async (uri) => {
  let data =
    await httpInstance.get(uri).then((res) => {
      return res.data;
    }).catch((err) => {
      throwErr(err);
      return null;
    })

  return data
}

export const postNewData = async (uri, request) => {
  let data =
    await httpInstance.post(uri, request).then((res) => {
      return res;
    }).catch((err) => {
      throwErr(err);
      return err.response.data
    })

  return data
}

export const patchData = async (uri, request) => {
  let data =
    await httpInstance.patch(uri, request).then((res) => {
      return res;
    }).catch((err) => {
      throwErr(err);
      return err.response.data
    })

  return data
}

export const putData = async (uri, request) => {
  let data =
    await httpInstance.put(uri, request).then((res) => {
      return res;
    }).catch((err) => {
      throwErr(err);
      return err.response.data
    })

  return data
}

export const deleteData = async (uri) => {
  let data =
    await httpInstance.delete(uri).then((res) => {
      return res.data;
    }).catch((err) => {
      throwErr(err);
    })

  return data
}

export const deleteBulkData = async (uri, request) => {
  let data = await httpInstance
    .delete(uri, { data: request })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throwErr(err);
    });

  return data;
};

export const deleteDataDifReturn = async (uri) => {
  let data =
    await httpInstance.delete(uri).then((res) => {
      return res;
    }).catch((err) => {
      throwErr(err);
    })

  return data
}